import { CoreFormFieldEmail } from '../fields/CoreFormFieldEmail';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import {
  FormFieldController,
  FormFieldControllerRulesProps,
} from './FormFieldController';

export const ContextFormFieldEmail = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field, fieldState }) => (
        <CoreFormFieldEmail
          label={rules?.required ? `${label} *` : label}
          error={fieldState.error?.message?.toString()}
          inputProps={{
            id: fieldPath,
            ...field,
            disabled,
            placeholder,
          }}
          inline={inline}
          helperText={helperText}
        />
      )}
    </FormFieldController>
  );
};
